var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22778 6.22646C6.5207 5.93359 6.99557 5.93364 7.28844 6.22656L12.0002 10.9392L16.7138 6.22646C17.0067 5.93359 17.4816 5.93364 17.7744 6.22656C18.0673 6.51948 18.0673 6.99435 17.7743 7.28722L13.0613 11.9994L17.7744 16.7125C18.0673 17.0054 18.0673 17.4803 17.7744 17.7732C17.4815 18.0661 17.0066 18.0661 16.7137 17.7732L12.0011 13.0605L7.28839 17.7732C6.99549 18.0661 6.52062 18.0661 6.22773 17.7732C5.93483 17.4803 5.93483 17.0054 6.22773 16.7125L10.9399 12.0003L6.22768 7.28712C5.93481 6.99419 5.93486 6.51932 6.22778 6.22646Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCancel);
export default __webpack_public_path__ + "static/media/x-cancel.05f44d864a0f9c6578b01aacf1135252.svg";
export { ForwardRef as ReactComponent };